import React from 'react'
import OrderHistoryContainer from '../../../../Components/Apps/ECommerce/OrderHistory'

export default function OrderHistory() {
  return (
    <div className='page-body'>
        <OrderHistoryContainer/>
    </div>
  )
}
